import { isSSR } from './ssr.esm.js';

function getSearchParams() {
  if (isSSR()) {
    return {};
  }

  var search = {};
  new URLSearchParams(window.location.search).forEach(function (value, key) {
    search[key] = value;
  });
  return search;
}

export { getSearchParams };
//# sourceMappingURL=search-params.esm.js.map
